import { jsx } from '@emotion/react';
import { ServiceIconShell } from '../ServiceIconShell/ServiceIconShell.es.js';
import { Img } from '../../display/Img/Img.es.js';
import { ServiceIconConfig } from './constants.es.js';

const ServiceIcon = ({ alt, "aria-hidden": ariaHidden = false, hasBorder = true, hasShadow = false, hasWhiteBackground = false, serviceName, size, src }) => {
  const iconSize = ServiceIconConfig[size].iconSize;
  return jsx(
    ServiceIconShell,
    { hasBorder, hasShadow, hasWhiteBackground, size },
    jsx(Img, { alt: alt || `${serviceName} logo`, "aria-hidden": ariaHidden, borderRadius: "none", height: iconSize, width: iconSize, objectFit: "contain", src })
  );
};

export { ServiceIcon };
//# sourceMappingURL=ServiceIcon.es.js.map
